
export default {
  props: {
    initialTab: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isLoginSignupPage() {
      return (
        this.$route.name === "login-signup" || this.$route.name === "signup"
      );
    }
  },
  data() {
    return {
      tab: 0
    };
  },
  mounted() {
    this.tab = this.initialTab;
  }
};
